export enum ProgramType {
    CV = "cv",
    CoverLetter = "cover-letter",
    PersonalStatement = "personal-statement",
    LinkedIn = "linkedin",
    ResumeTemplate = "resume-template",
    UKJobReadyProgram = "uk-job-ready-program",
}

export interface ProgramData {
  id: ProgramType;
  to: string;
  label: string; // navbar header
  title: string; // landing page title
  description: string;
  /** Internal product ID sent to /api/create-checkout-session */
  productId: string;
}

export const programData: ProgramData[] = [
  {
    id: ProgramType.CV,
    to: "/program/cv",
    label: "CV",
    title: "CV Consulting",
    description: "UK-standard CV rewriting and strategic structuring for recruiters.",
    productId: "cv",
  },
  {
    id: ProgramType.CoverLetter,
    to: "/program/cover-letter",
    label: "Cover Letter",
    title: "Cover Letter Consulting",
    description: "Logic-driven UK-style cover letter narrative building.",
    productId: "cover-letter",
  },
  {
    id: ProgramType.PersonalStatement,
    to: "/program/personal-statement",
    label: "Personal Statement",
    title: "Personal Statement Consulting",
    description: "Academic positioning and narrative design for UK uni admissions.",
    productId: "personal-statement",
  },
  {
    id: ProgramType.LinkedIn,
    to: "/program/linkedin",
    label: "LinkedIn",
    title: "LinkedIn Optimisation",
    description: "Professional branding and algorithm-optimised LinkedIn rebuild.",
    productId: "linkedin",
  },
  {
    id: ProgramType.ResumeTemplate,
    to: "/program/resume-template",
    label: "Resume Template",
    title: "Resume Templates",
    description: "Modern, UK-style resume templates ready to use.",
    productId: "resume-template",
  },
  // {
  //   id: ProgramType.UKJobReadyProgram,
  //   to: "/program/uk-job-ready-program",
  //   label: "UK Job Ready Program",
  //   title: "UK Job Ready Program",
  //   description: "Expert 1:1 feedback for international students entering the UK job market.",
  //   productId: "cv",
  // },
];
